import { Tooltip } from "@/components/ui/tooltip";
import { ProductionGrainListEntity } from "@/pages/production-abm/production-grains/schema/production-grains.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: ProductionGrainListEntity;
  handleDetail: (id: number) => void;
}

export const ProductionGrainsActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item.id)}
          data-testid="production-grains-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
